import * as React from "react";
const SvgTutorials = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 24 24", style: {
  enableBackground: "new 0 0 24 24"
}, xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M22,9l-4.2,2.5V20H6.2v-8.5l-2.1-1.2v7H3.4V9.8L2,9l10-4.8L22,9z M12,4.9L3.5,9l8.5,5.2L20.6,9L12,4.9z M17.1,19.3v-7.4 L12,15l-5.2-3.1v7.4H17.1z" }));
export default SvgTutorials;
